import React from "react";
import PWMPins from "../images/Raspberry_pi_3_PWM_pins-removebg-preview.png"
import LEDInterfacing from "../images/PWM_based_LED_control_using_Pi-removebg-preview.png"
function PWMGeneration() {
  return (
    <div style={{ padding: "20px", lineHeight: "1.8" }}>
      <h1>Raspberry Pi PWM Generation using Python and C</h1>

      <h2>Introduction to PWM</h2>

      <p>
        PWM (Pulse Width Modulation) is a modulation technique by which the width of pulse is varied while keeping the frequency constant.
      </p>

      <p>
        Through PWM technique, we can control the power delivered to the load by using ON-OFF signal.
      </p>

      <p>
        The PWM signals can be used for applications such as controlling the speed of DC motors, changing intensity of an LED, controlling Servo motors, etc.
      </p>

      <p>
        The GIF shown below depicts the use of PWM for intensity control of an LED.
      </p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/304/description/PWM.gif"
        alt="PWM Concept"
        style={imgStyle}
      />

      <h2>Raspberry Pi PWM</h2>

      <p>Raspberry Pi has two PWM channels i.e. PWM0 and PWM1.</p>

      <p>PWM pins for the two PWM channels on 40-pin P1 header are as follows:</p>

      <table border="1" cellPadding="10" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>GPIO Pin</th>
            <th>PWM0/PWM1</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>GPIO12</td><td>PWM0</td></tr>
          <tr><td>GPIO18</td><td>PWM0</td></tr>
          <tr><td>GPIO13</td><td>PWM1</td></tr>
          <tr><td>GPIO19</td><td>PWM1</td></tr>
        </tbody>
      </table>

      <p>
        The PWM pins on Raspberry Pi 40-pin P1Header is shown in below figure,
      </p>

      <img
        src={PWMPins}
        alt="PWM Pins"
        style={imgStyle}
      />

      <p><strong>Raspberry Pi PWM Pins</strong></p>

      <p>
        The PWM pins on Raspberry Pi are shared with audio subsystem. Thus, we can have either PWM output or Audio output.
      </p>

      <h2>LED Interfacing with Raspberry Pi</h2>

      <img
        src={LEDInterfacing}
        alt="LED Interfacing"
        style={imgStyle}
      />

      <p>Control LED Brightness using PWM on Raspberry Pi</p>

      <h2>Example</h2>

      <p>
        Here, we are going to generate PWM on Raspberry Pi. This PWM output is connected to an LED which will show change in intensity.
      </p>

      <p>Let’s generate PWM using C and Python language.</p>

      <h2>Generate PWM using Python</h2>

      <p>
        The PWM generated by Python on Raspberry Pi is software PWM. This PWM has timing resolution of 1 us which is better than Software PWM generated using C (WiringPi library).
      </p>

      <h3>Python Program</h3>

      <pre style={codeBlock}>
{`'''
Control the Brightness of LED using PWM on Raspberry Pi
http://www.electronicwings.com
'''

import RPi.GPIO as GPIO
from time import sleep

ledpin = 12
GPIO.setwarnings(False)
GPIO.setmode(GPIO.BOARD)
GPIO.setup(ledpin,GPIO.OUT)
pi_pwm = GPIO.PWM(ledpin,1000)
pi_pwm.start(0)

while True:
    for duty in range(0,101,1):
        pi_pwm.ChangeDutyCycle(duty)
        sleep(0.01)
    sleep(0.5)
    
    for duty in range(100,-1,-1):
        pi_pwm.ChangeDutyCycle(duty)
        sleep(0.01)
    sleep(0.5)`}
      </pre>

      <h2>PWM Functions in Python</h2>

      <h3>Create PWM Object</h3>

      <pre style={codeStyle}>
{`pi_pwm = GPIO.PWM (Pin no., frequency)`}
      </pre>

      <p>
        Create an Object of class PWM which is a part of RPi.GPIO library.
      </p>

      <ul>
        <li>Pin no. – PWM pin no on which PWM will be generated.</li>
        <li>Frequency – frequency of PWM</li>
      </ul>
      <p>Now, we can call PWM functions of RPi.GPIO library by using PWM object</p>

      <p>
        Note: The PWM which is generated here is Software PWM and can generate on any GPIO pin.
      </p>

      <h3>start (Duty Cycle)</h3>
      <p>It is used to start PWM generation of specified Duty Cycle.</p>

      <h3>ChangeDutyCycle(Duty Cycle)</h3>
      <p>This function is used to change the Duty Cycle of signal.</p>

      <h3>ChangeFrequency(frequency)</h3>
      <p>This function is used to change the frequency (in Hz) of PWM.</p>

      <h3>stop()</h3>
      <p>This function is used to stop the PWM generation.</p>

      <h2>Generate PWM using C</h2>

      <h3>Hardware PWM</h3>

      <pre style={codeBlock}>
{`#include <wiringPi.h>
#include <stdio.h>
#include <stdlib.h>

const int PWM_pin = 1;

int main (void)
{
  int intensity ;            

  if (wiringPiSetup () == -1)
    exit (1) ;

  pinMode (PWM_pin, PWM_OUTPUT) ;

  while (1)
  {
    for (intensity = 0 ; intensity < 1024 ; ++intensity)
    {
      pwmWrite (PWM_pin, intensity) ;
      delay (1) ;
    }

    for (intensity = 1023 ; intensity >= 0 ; --intensity)
    {
      pwmWrite (PWM_pin, intensity) ;
      delay (1) ;
    }
  }
}`}
      </pre>
  <p><h1>WiringPi PWM Functions in C</h1>
<h6>pwmWrite (PWM pin, PWM value) </h6>

where,

           <li>PWM pin – On-chip PWM Pin no. on which PWM is to be generated.</li> 

            <li>PWM value – value to be written in PWM register for PWM generation. This value is in the range of 0-1023.</li> 

We can generate PWM on Raspberry Pi using analogWrite() function like Arduino function. But to use this function we have to include some extra modules.

 

<h6>pwmSetClock (divisor)</h6>

This function is used to set the divisor for PWM Clock.

 

<h6>pwmSetMode (mode)</h6>

            mode – PWM generation can be done in two modes i.e. Balanced and Mark:Space mode. We can provide parameter to select above mode as, PWM_MODE_BAL or PWM_MODE_MS. The default PWM mode on Raspberry Pi is Balanced mode.

 

<h6>pwmSetRange (range)</h6>

This function is used to set the range for PWM generation in PWM generator register. The default range is 1024.

 
</p>
<h1>Software PWM using C</h1>

We can generate PWM on every GPIO pin of Raspberry Pi using Software PWM library of wiringPi.

<p>Here, we will change the intensity of LED using software PWM on Raspberry Pi.</p>

      <h2>Software PWM using C</h2>

      <pre style={codeBlock}>
{`#include <wiringPi.h>
#include <stdio.h>
#include <softPwm.h>

int main(){
    int PWM_pin = 1;
    int intensity;

    wiringPiSetup();
    pinMode(PWM_pin,OUTPUT);
    softPwmCreate(PWM_pin,1,100);

    while (1){
        for (intensity = 0; intensity < 101; intensity++){
            softPwmWrite (PWM_pin, intensity);
            delay (10);
        }

        for (intensity = 100; intensity >= 0; intensity--){
            softPwmWrite (PWM_pin, intensity);
            delay (10);
        }
    }
}`}
      </pre>

      <h2>Functions Used</h2>

      <p>
        To generate Software PWM using wiringPi library, we have to include softPwm.h header file.
      </p>

      <h5>softPwmCreate (Pin no., initial value, PWM Range)</h5>

      <p>
        This function is used to create software controlled PWM.
      </p>

      <ul>
        <li><b>Pin no.</b> – GPIO pin on which we want to generate PWM.</li>
        <li><b>Initial value</b> – specify any initial value which is in between PWM range.</li>
        <li><b>PWM range</b> – we can provide range i.e. frequency range for PWM. Use 100 for the PWM range then the value can be anything from 0 to 100. These values are useful to generate PWM of various Duty cycle.</li>
      </ul>

      <p>
        <b>Note: </b> The minimum pulse width is 100 us to maintain low CPU usage. For this minimum pulse width, suggested PWM range is 100 which gives 100 Hz frequency. If we lower the value of PWM range then we will get higher frequency with less resolution. Or we can increase the value of PWM range, and then will get lower frequency with better resolution.
      </p>

      <h5>softPwmWrite(Pin no., value)</h5>

      <p>This function is used to change the value of PWM on PWM pin.</p>
      <p> <b>Pin no.</b> - GPIO pin on which we want to generate PWM.

          </p>
          <p><b>value </b>– value is PWM value.</p>
      <h2>Software PWM or Hardware PWM</h2>

      <p>
        When we have to generate more number of PWM and our application is low timing resolution tolerant, then we can use Software PWM.
      </p>

      <p>
        But if our application needs higher timing resolution PWM, then we need to use Hardware PWM.
      </p>
    </div>
  );
}

const imgStyle = {
  width: "100%",
  maxWidth: "700px",
  margin: "20px 0",
};

const codeStyle = {
  background: "#111",
  color: "#0f0",
  padding: "10px",
};

const codeBlock = {
  background: "#1e1e1e",
  color: "#fff",
  padding: "10px",
};

export default PWMGeneration;